var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayCenterOffersBanner)?_c('div',_vm._l((_vm.centerSeatOfferDetails),function(detail){return _c('center-offers-banner',{key:detail.seatId,attrs:{"centerSeatOfferDetail":detail}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }